export const messageTypes = [
  { type: 'EMAIL', value: 'EMAIL' },
  { type: 'SMS', value: 'SMS' },
  { type: 'PUSH', value: 'PUSH' },
];
